import { Text, TextSize } from '@shared/components/Text';
import { View, ViewProps } from '@shared/components/View';
import { MBIconV2, MBIconV2Name } from '@shared/components/image';
import { grid } from '@shared/styles';
import styles from './MenuNote.module.css';

interface MenuNoteProps extends ViewProps {
  textSize?: TextSize;
  icon?: MBIconV2Name;
  iconSize?: number;
}

export function MenuNote({
  children,
  textSize = 'body2',
  icon = 'info-outline',
  iconSize = grid(2.5),
  ...rest
}: MenuNoteProps) {
  return (
    <View row className={styles.menuNote} role="note" {...rest}>
      <View paddingRight={1}>
        <MBIconV2 name={icon} size={iconSize} />
      </View>
      <View flex>
        <Text size={textSize}>{children}</Text>
      </View>
    </View>
  );
}
